import { useIntl } from 'react-intl';

export const DocumentUploadingProgress = ({ onCancel }: { onCancel: () => void }) => {
    const intl = useIntl();
    return (
        <div className='flex-1-0' style={{ height: '34px' }}>
            <div className='display-flex justify-content-between text-size-12 margin-bottom-3'>
                <span className='text-color-darker cursor-pointer' onClick={onCancel}>
                    {intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.common.upload.abort',
                    })}
                </span>
            </div>
            <div className='progress'>
                <div
                    className='progress-bar progress-bar-striped progress-bar-animated progress-bar-primary'
                    style={{ width: '100%' }}
                />
            </div>
        </div>
    );
};
